import { RAW_STARTER_CSV } from "./starterChecklistRaw";
import { parseChecklistCsv } from "./checklistParser";

// The team's full listing checklist, ready to load into the Task Template.
export const STARTER_CHECKLIST = parseChecklistCsv(RAW_STARTER_CSV);
